module.exports = __webpack_public_path__ + "img/home5.1bc45a7a.jpg";